import { ZObjectItem, zObjectItem } from "src/types/ZObjectItem";
import { ZAttribute } from "src/types/ZAttribute";
import { ZGroup } from "src/types/ZGroup";
import { ZUid } from "src/types/zUid";
import { apiObjUrl } from "../apiUrl";
import { restWithObjectVersion } from "../restWithObjectVersion";

export const loadObject = async (
  objectId: ZUid,
  options: {
    stateId?: ZUid | null;
    translate?: boolean;
  } = {},
) => {
  const { stateId, translate } = options;
  let url = apiObjUrl(`/objects/${objectId}`);
  if (stateId) url += `/${stateId}`;
  const resp = await restWithObjectVersion.get(url, { translate });
  return zObjectItem.parse(resp.data);
};

export const getAttributesFromObject = (
  object: ZObjectItem,
): Record<ZUid, ZAttribute> => {
  const attrMap: Record<ZUid, ZAttribute> = {};
  const addAtributes = (attrs?: ZAttribute[] | null) =>
    attrs?.forEach((a) => {
      attrMap[a.id] = a;
    });
  addAtributes(object.attributes);
  const onGroup = (group: ZGroup) => {
    addAtributes(group.attributes);
    group.groups?.forEach(onGroup);
  };
  object.groups?.forEach(onGroup);
  return attrMap;
};
